/**
 * One tenant, as the vendor sees it (container, phase 7b): its detail, and
 * suspend / reactivate. Live through the `tenant` change kind.
 */
import { useNow, useVendorTenant } from '../app/hooks.js';
import { SuspendTenantDialog } from '../components/vendor/SuspendTenantDialog.js';
import { TenantDetail } from '../components/vendor/TenantDetail.js';
import { Button } from '../components/ui/button.js';
import { useVendorAdmin } from './VendorLayout.js';
import { useTenantStatusActions } from './VendorTenantsView.js';

function messageOf(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

export function VendorTenantView({ tenantId }: { readonly tenantId: string }) {
  const detail = useVendorTenant(tenantId);
  const canAdmin = useVendorAdmin();
  const now = useNow(30_000);
  const status = useTenantStatusActions();
  if (detail.data === undefined) {
    if (detail.error !== null) {
      return (
        <div className="grid gap-4" role="alert" data-testid="vendor-tenant-failed">
          <p className="text-sm text-destructive">Could not load the tenant: {messageOf(detail.error)}</p>
          <Button variant="outline" className="w-fit" onClick={() => void detail.refetch()}>
            Retry
          </Button>
        </div>
      );
    }
    return <p className="p-8 text-center text-sm text-muted-foreground">Loading the tenant…</p>;
  }
  const { tenant } = detail.data;
  return (
    <>
      <TenantDetail detail={detail.data} canAdmin={canAdmin} nowMs={now} onSuspend={() => status.open('suspend', tenant.tenantId)} onReactivate={() => status.open('reactivate', tenant.tenantId)} />
      <SuspendTenantDialog mode={status.action?.mode ?? null} tenant={{ tenantId: tenant.tenantId, name: tenant.name }} pending={status.pending} error={status.error} onClose={status.close} onConfirm={status.confirm} />
    </>
  );
}
